export const TOOLS_LIST = title => [
  {
    title: "Minha conta",
    color: "orange",
    options: [
      {
        permission: "coproducoes",
        route: "tools-coproductions",
        name: "Coproduções",
        icon: "ph ph-handshake",
        description: "Compartilhe o produto com seus coprodutores."
      },
      {
        permission: "central-de-colaboradores",
        route: "tools-partners",
        name: "Central de colaboradores",
        icon: "ph ph-users-three",
        description: "Libere permissões de acesso para seus colaboradores."
      }
    ]
  },
  {
    title: "Integrações",
    color: "orange",
    options: [
      {
        permission: "api-e-notificacoes",
        route: "tools-webhook",
        name: "Webhook (API e notificações)",
        icon: "ph ph-webhooks-logo",
        description:
          "Configure suas integrações externas e notificações de vendas com a API da " +
          title
      },
      {
        permission: "lead-list",
        route: "tools-leadlist",
        name: "Lead List",
        icon: "ph ph-envelope-simple",
        description:
          "Integre seu provedor de email à " +
          title +
          " para organizar seus leads."
      },
      {
        permission: "e-mail-marketing",
        route: "tools-email-marketing",
        name: "E-mail marketing",
        icon: "ph ph-at",
        description: "Integre seu provedor de E-mail marketing à " + title
      },
      {
        permission: "automacoes",
        route: "tools-automations",
        name: "Automações",
        icon: "ph ph-arrows-in",
        description: "Integre suas ferramentas de automação à " + title
      },
      {
        permission: "notas-fiscais",
        route: "tools-invoices",
        name: "Notas Fiscais",
        icon: "ph ph-files",
        description:
          "Integre sua plataforma de emissão de notas fiscais à " + title
      },
      {
        permission: "kajabi",
        route: "tools-member-area",
        name: "Área de membros",
        icon: "ph ph-monitor-play",
        description: "Integre sua plataforma de área de membros à " + title
      },
      {
        permission: "zoom",
        route: "tools-zoom",
        name: "Zoom",
        icon: "ph ph-webcam",
        description: "Integre sua conta de zoom para aulas ao vivo."
      },
      {
        permission: "certificacoes-mec",
        route: "tools-mec-certifications",
        name: "Certificações MEC",
        icon: "ph ph-graduation-cap",
        description: "Integre sua secretaria digital à " + title
      }
    ]
  },
  {
    title: "Ads e Rastreamento",
    color: "orange",
    options: [
      {
        permission: "pixel-de-rastreamento",
        route: "tools-google-ads",
        name: "Google Ads",
        icon: "ph ph-google-logo",
        description: "Integre sua conta do Google Ads à " + title
      },
      {
        permission: "pixel-de-rastreamento",
        route: "tools-facebook-ads",
        name: "Facebook Ads",
        icon: "ph ph-facebook-logo",
        description: "Integre sua conta do Facebook Ads à " + title
      },
      {
        permission: "pixel-de-rastreamento",
        route: "tools-google-analytics",
        name: "Google Analytics",
        icon: "ph ph-chart-bar",
        description: "Integre sua conta do Google Analytics à " + title
      },
      {
        permission: "pixel-de-rastreamento",
        route: "tools-kwai-ads",
        name: "Kwai Ads",
        icon: "ph ph-film-slate",
        description: "Integre sua conta do Kwai Ads à " + title
      }
    ]
  }
];
